<template>
    
    <ul style=" list-style-type: none;padding: 0;">
        <router-link to="/"> <li class="m-3 text-info">Accueil</li></router-link>
        <!-- concept-digitable -->
        <router-link to="/"><li class="m-3 text-info">Concept</li></router-link> 
        <!-- atouts-sacs-publicitaires -->
        <router-link to="/"> <li class="m-3 text-info">Atouts</li></router-link>

    </ul>

</template>

<script>
export default ({
    name: "footer-Shop"
})
</script>


